$(document).ready(function() {
	$('.minus-btn').click(function () {
		var $input = $(this).parent().find('input.qty_input');
		var count = parseInt($input.val()) - 1;
		count = count < 1 ? 1 : count;
		$input.val(count);
		$input.change();
		return false;
	});
	$('.plus-btn').click(function () {
		var $input = $(this).parent().find('input.qty_input');
		$input.val(parseInt($input.val()) + 1);
		$input.change();
		return false;
	});
});